module.exports = __webpack_public_path__ + "static/media/pathology_2.05d9fabb.jpeg";